<template>
    <div class="map" :class="rootClasses" :style="[scrollLockStyles]">
        <div class="map--positionner">
            <keep-alive>
                <cmp-mapbox-map v-if="isPartialLoaded"
                        class="map--content"
                        :class="[mapContentClasses]">
                </cmp-mapbox-map>
            </keep-alive>
            <cmp-map-nav v-if="!isMobile" class="map--map-nav" facet="split"></cmp-map-nav>

            <transition name="trs-simple-fade">
                <router-link v-if="isLocation" class="u-reset map--logo"
                        v-bind="partial.home_link">
                    <img class="map--logo-image" :src="'img/im_vehi-logo.svg' | static" alt="">
                </router-link>
            </transition>

            <!--<pre v-text="partial"></pre>-->
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import bemMixin from 'framework/mixins/bem';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import cmsPartialMixin from 'framework/mixins/cms/cms-partial';
    import scrollLockHelperMixin from 'framework/mixins/scroll-lock-helper';


    export default {
        mixins: [
            bemMixin('map'),
            isMobileMixin,
            cmsPartialMixin,
            scrollLockHelperMixin,
        ],
        props: {
            partialName: {
                type: String,
                default: 'map',
            },
        },
        data() {
            return {
                map: null,
            };
        },
        computed: {
            ...mapGetters(['pageType', 'isHomeIntroDismissed']),
            rootClasses() {
                const attachToBottom = this.isMobile && this.isHomeIntroDismissed;

                return [
                    this.bemAdd(attachToBottom ? '' : 'attach-to-bottom'),
                ];
            },
            isLocation() {
                return this.pageType === 'page-location';
            },
            mapContentClasses() {
                return [
                    this.bemAdd(this.isPartialAllowed ? 'is-allowed' : '', 'content'),
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/map/index.vue?6e78e7d4